{
  "name": "prime",
  "version": "3.1.68",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "watch": "ng build --watch --configuration development",
    "build": "ng build --configuration production && npm version patch",
    "build:ci": "ng build --configuration production",
    "lint": "ng lint prime --fix",
    "sentry-1": "cross-env CURRENT_VERSION=\"$npm_package_version\" npm run sentry-finalize",
    "sentry-finalize": "cross-env-shell \"sentry-cli releases new prime-v$CURRENT_VERSION --finalize\"",
    "sentry-2": "cross-env CURRENT_VERSION=\"$npm_package_version\" npm run sentry-releases",
    "sentry-releases": "cross-env-shell \"sentry-cli releases set-commits prime-v$CURRENT_VERSION --auto\"",
    "sentry": "npm run sentry-1 && npm run sentry-2",
    "git-version": "git push",
    "release": "npm run sentry && npm run build && npm run git-version"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.6",
    "@angular/cdk": "^22.1.6",
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/localize": "^22.1.6",
    "@angular/material": "^22.1.6",
    "@angular/material-moment-adapter": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/platform-browser-dynamic": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@angular/service-worker": "^22.1.6",
    "@dhutaryan/ngx-mat-timepicker": "^21.0.0",
    "@fortawesome/fontawesome-free": "^7.3.1",
    "@jsverse/transloco": "^8.4.0",
    "@jsverse/transloco-persist-lang": "^8.4.0",
    "@ng-bootstrap/ng-bootstrap": "21.0.0",
    "@ngrx/effects": "^22.0.1",
    "@ngrx/entity": "^22.0.1",
    "@ngrx/operators": "^22.0.1",
    "@ngrx/router-store": "^22.0.1",
    "@ngrx/store": "^22.0.1",
    "@ngx-loading-bar/core": "^7.0.1",
    "@ngx-loading-bar/router": "^7.0.1",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^10.74.0",
    "@types/lodash": "^4.17.25",
    "@uppy/angular": "^2.0.0",
    "@uppy/core": "^6.0.1",
    "@uppy/dashboard": "^6.0.0",
    "@uppy/drag-drop": "^6.0.0",
    "@uppy/image-editor": "^5.0.0",
    "@uppy/progress-bar": "^4.3.2",
    "@uppy/xhr-upload": "^6.0.0",
    "ag-grid-angular": "^36.1.0",
    "ag-grid-community": "^36.1.0",
    "animate.css": "4.1.1",
    "bootstrap": "5.3.8",
    "bootstrap-icons": "^1.13.1",
    "chart.js": "^4.5.1",
    "chartjs-plugin-datalabels": "^2.2.0",
    "line-awesome": "1.3.0",
    "lodash": "^4.18.1",
    "material-design-icons": "^3.0.1",
    "moment": "^2.31.0",
    "ng-gallery": "^12.0.0",
    "ng-inline-svg-2": "^20.0.2",
    "ngx-clipboard": "^16.0.0",
    "ngx-highlightjs": "^14.0.1",
    "ngx-infinite-scroll": "^22.0.0",
    "ngx-mat-select-search": "^9.0.0",
    "ngx-permissions": "^19.0.0",
    "rxjs": "~7.8.2",
    "socicon": "3.0.5",
    "tslib": "^2.8.1",
    "uuid": "^14.0.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.5.0",
    "@angular-eslint/eslint-plugin": "^22.5.0",
    "@angular-eslint/eslint-plugin-template": "^22.5.0",
    "@angular-eslint/schematics": "^22.5.0",
    "@angular-eslint/template-parser": "^22.5.0",
    "@angular/build": "^22.1.8",
    "@angular/cli": "~22.1.8",
    "@angular/compiler-cli": "^22.1.6",
    "@types/bootstrap": "^5.2.11",
    "@types/node": "^26.5.1",
    "@types/sass-loader": "8.0.10",
    "@types/uuid": "^11.0.0",
    "@typescript-eslint/eslint-plugin": "^8.70.0",
    "@typescript-eslint/parser": "^8.70.0",
    "cross-env": "^10.1.0",
    "css-loader": "^7.1.5",
    "eslint": "^10.10.0",
    "sass-loader": "^17.0.1",
    "typescript": "~6.0.3"
  },
  "resolutions": {
    "autoprefixer": "10.4.5"
  }
}
